import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Tabs } from 'components/UI'
// types
import { TabsProps } from '@mui/material'

export const StyledTabs = styled((props: TabsProps) => <Tabs {...props} />)`
  margin-bottom: 12px;

  .MuiButtonBase-root {
    min-height: unset;
    padding-right: 0;
  }

  .MuiTab-root {
    display: flex;
    flex-direction: row-reverse;
    gap: 8px;
  }
`
